"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PatternBaseGLFilter = _interopRequireDefault(require("./PatternBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PatternSquareGLFilter extends _PatternBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;						

        uniform sampler2D t_tex;		
        varying highp vec2 v_uv;	
        uniform float zoom;
        uniform bool greyScale;
        uniform float greyLevels;
        uniform float aspect;
        uniform float blackWhiteThreshold;  //black to white boundary range -1.0 - 1.0
        uniform bool isGeneratingTile;
        
        void main(void) {
            vec2 uv = zoom * v_uv;

            if (!isGeneratingTile)
            {
                // longEdge is the offaet based on the number of repetitions of the pattern in the wider direction
                // (always 4 in the smaller dimension due to default zoom value of 4.0)
                // Corrrect the offset of the initial patterns so the very center of the pattern edges always falls
                // in the very center of the screen (Where the inset camera lies)=
    
                // The "wide" variables below are used only for square patterns when in Capture mode.
                // For speed, we create the textures directly from camera memory, meaning they are not square
                // and require these corrections.
                // Anywhere but capture, the image is now square and they are passed in as 1.0 and 0.0
                if(aspect >= 1.)
                {
                    float longEdgeOffsetBigAspectX = mod(zoom * aspect, 2.) / 2.;
                    float longEdgeOffsetBigAspectY = mod(zoom, 2.) / 2.;
                    uv.x = fract(uv.x * aspect + (1. - longEdgeOffsetBigAspectX));
                    uv.y = fract(uv.y + (1. - longEdgeOffsetBigAspectY));
                }
                else
                {
                    float longEdgeOffsetSmallAspectX = mod(zoom, 2.) / 2.;
                    float longEdgeOffsetSmallAspectY = mod(zoom / aspect, 2.) / 2.;
                    uv.x = fract(uv.x + (1. - longEdgeOffsetSmallAspectX));
                    uv.y = fract(uv.y / aspect + (1. - longEdgeOffsetSmallAspectY));
                }
            } else {
                uv.y = 1.0 - uv.y;
            }

            if(greyScale == true) {
                vec4 texColor = texture2D(t_tex, uv);
                int bitGrey = int((0.21 * texColor.x + 0.72 * texColor.y + 0.07 * texColor.z) * greyLevels + blackWhiteThreshold);
                float grey = (float(bitGrey) / (greyLevels - 1.));
                gl_FragColor = vec4(grey, grey, grey, 1.0);
            }
            else {
                gl_FragColor = texture2D(t_tex, uv);
            }

            // debugging
            //	gl_FragColor = vec4(zoom, 0, 0, 1);
        }
        `;
    super(fsSource);
    this.isGeneratingTile = false;
  }

  initUniformLocations(gl, program) {
    let uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.isGeneratingTile = gl.getUniformLocation(program, 'isGeneratingTile');
    return uniformLocations;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    gl.uniform1f(uniformLocations.isGeneratingTile, this.isGeneratingTile);
    super.willDraw(gl, uniformLocations, attributeLocations, flip);
  }

}

exports.default = PatternSquareGLFilter;